// extracted by mini-css-extract-plugin
module.exports = {"title":"SuggestionsComplains_title__c0TRe","para":"SuggestionsComplains_para__c-OPa"};